module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/bangdan_icon_more.6a8b0.png";